import axiosInstance from "../../routes/axiosConfig";

const permissionService = {
  getAll: async () => {
    const { data } = await axiosInstance.get("/permissions");
    return data;
  },

  saveAll: async (items) => {
    const { data } = await axiosInstance.put("/permissions", items);
    return data;
  },

  getMine: async () => {
    const { data } = await axiosInstance.get("/permissions/me");
    return data;
  },
};

export default permissionService;
